import { useEffect, useState } from 'react'
import { Button } from '../../components/button'
import { Checkbox } from '../../components/checkbox'
import { Slider } from '../../components/slider'
import './styles.scss'
import { THEMES, THEMES_IMGS } from './constants'
import { ThemeChoices } from './types'
import { useTheme } from '../../hooks/setup/useTheme'
import { useSteps } from '../../hooks/setup/useSteps'

export const SystemTheme = () => {
  const { register, getData: getTheme } = useTheme()
  const { nextStep } = useSteps()
  const [themeSelected, setThemeSelected] = useState<ThemeChoices>(
    ThemeChoices.THEME_ID_OBSIDIAN
  )

  useEffect(() => {
    const loadTheme = async () => {
      const t = await getTheme()

      if (!t) return

      setThemeSelected(t.theme as ThemeChoices)
    }

    loadTheme()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handlerSelectTheme = async (themeId: ThemeChoices) => {
    if (themeId === themeSelected) return

    await register(themeId)
    setThemeSelected(themeId)
  }

  const handlerOnSubmit = async () => {
    await register(themeSelected)
    await nextStep()
  }

  return (
    <div className="container-main-system-config">
      <div className="content-title">
        <strong>Configure o seu tema</strong>

        <p>
          Selecione um dos temas abaixo e personalize de acordo com a identidade
          da sua empresa:
        </p>
      </div>

      <div className="container-enter-data">
        <Slider
          sliders={THEMES}
          item={(item) => (
            <div
              className={`container-choices-themes ${themeSelected === item.id ? 'selected' : ''}`}
              onClick={() => handlerSelectTheme(item.id)}
            >
              <Checkbox
                id={String(item.id)}
                checked={item.id === themeSelected}
                onChange={(event) =>
                  handlerSelectTheme(event.target.id as ThemeChoices)
                }
              />

              <div className="choice-theme-info">
                <strong>{item.title}</strong>
                <p>{item.subTitle}</p>
              </div>
            </div>
          )}
        />

        <div className="container-preview-theme">
          {THEMES_IMGS[themeSelected].map(({ id, img }) => {
            return <img key={id} src={img} alt={img} />
          })}
        </div>

        <div className="content-btn-submit">
          <Button
            onClick={handlerOnSubmit}
            type="button"
            className="content-btn-submit"
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  )
}
